import React from 'react'
import { useServiceContext } from '../../root'
import ActionsMenuBig from '../../components/shared/ActionsMenuBig'
import useDocUploadDataService from '../../hooks/useDocUploadDataService'

const PageMenu: React.FC = () => {
  // If you need context, you can use it here:
  // const context = useServiceContext();
  const { assembleDocUploadData } = useDocUploadDataService()

  const settings = {
    menuId: 'page',
    items: [
      {
        value: 'Upload Document(s)',
        action: function () {
          assembleDocUploadData()
        }
      }
    ]
  }

  return (
    <div>
      <ActionsMenuBig {...settings} />
    </div>
  )
}

export default PageMenu
